module.exports = __webpack_public_path__ + "static/media/Abs.0802a1b2.jpeg";